/*
 * Hero autoplay videos (video/autoplay + video/autoplayv2 templates).
 *
 * iOS Safari does not reliably honor the `media` attribute on <source> elements
 * inside <video>, so on iPhone the browser often fails to pick a playable source
 * and the autoplay video stays blank. We take over here: evaluate the <source>
 * media queries ourselves, set video.src directly (which makes WebKit ignore the
 * unreliable <source> children), force muted + playsinline, and call play() with
 * a one-time interaction fallback for Low Power Mode.
 */

function pickSource(video) {
    const sources = Array.prototype.slice.call(video.querySelectorAll('source'));
    let fallback = null;

    for (let i = 0; i < sources.length; i++) {
        const source = sources[i];
        const src = source.getAttribute('src');

        if (!src) {
            continue;
        }

        const media = source.getAttribute('media');

        if (!media) {
            if (!fallback) {
                fallback = src;
            }
            continue;
        }

        if (window.matchMedia(media).matches) {
            return src;
        }
    }

    return fallback || (sources.length ? sources[0].getAttribute('src') : null);
}

function initHeroVideo(video) {
    const src = pickSource(video);

    if (src && video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        video.load();
    }

    // Required for reliable iOS muted inline autoplay.
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    const tryPlay = function () {
        const result = video.play();

        if (result && typeof result.catch === 'function') {
            result.catch(function (e) {
                // Temporary on-device diagnostic (remove once confirmed working):
                // NotAllowedError = autoplay policy / Low Power Mode;
                // NotSupportedError = source/codec problem.
                console.log('hero play failed', e.name, e.message);
            });
        }
    };

    tryPlay();

    // Low Power Mode / first-interaction fallback.
    const retry = function () {
        tryPlay();
        document.removeEventListener('touchstart', retry);
        document.removeEventListener('click', retry);
    };

    document.addEventListener('touchstart', retry, { once: true, passive: true });
    document.addEventListener('click', retry, { once: true });
}

function initAll() {
    const videos = document.querySelectorAll('.hero__video, .hero-video-autoplay__video');

    Array.prototype.forEach.call(videos, initHeroVideo);
}

// Run even if the bundle loads after DOMContentLoaded has already fired.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/videos/hero-autoplay.js